import styled from 'styled-components';
import { SIZE, FONTS, COLORS } from '@app/src/ui';

interface Props {
  bgColor?: string;
}

export const Reserved = styled.div`
  background: ${(props: Props) => props.bgColor || '#000'};
  font-size: 12px;
  font-family: ${FONTS.OPEN_SANS};
  line-height: 36px;
  text-align: center;
  color: ${COLORS.GRAY_PLACEHOLDER};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    color: #fff;
  }

  @media (min-width: ${SIZE.TABLET_BREAK}) {
    text-align: left;
  }
`;
